var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecyclingWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4 18.4L22.85 11.05L19.9 6.15C19.5 5.48333 18.925 5.15 18.175 5.15C17.425 5.15 16.85 5.48333 16.45 6.15L11.55 14.3L18.4 18.4ZM37.75 32L33.3 24.6L40.25 20.6L43.45 25.95C43.8167 26.5167 44.0083 27.1583 44.025 27.875C44.0417 28.5917 43.9 29.2333 43.6 29.8C43.2667 30.4667 42.775 31 42.125 31.4C41.475 31.8 40.7667 32 40 32H37.75ZM32 46L24 38L32 30V34H41.5L38.6 39.8C38.2333 40.4667 37.7333 41 37.1 41.4C36.4667 41.8 35.7667 42 35 42H32V46ZM12.65 42C11.9833 42 11.375 41.825 10.825 41.475C10.275 41.125 9.86667 40.6667 9.6 40.1C9.33333 39.5667 9.20833 39.0083 9.225 38.425C9.24167 37.8417 9.4 37.3 9.7 36.8L11.4 34H20V42H12.65ZM7.7 36.3L4.45 29.8C4.15 29.2 4.00833 28.5583 4.025 27.875C4.04167 27.1917 4.23333 26.55 4.6 25.95L5.4 24.6L2 22.55L12.95 19.8L15.7 30.8L12.25 28.7L7.7 36.3ZM34.7 19.2L23.75 16.45L27.2 14.4L20.95 4H28C28.7 4 29.3583 4.175 29.975 4.525C30.5917 4.875 31.0833 5.35 31.45 5.95L34.05 10.3L37.45 8.2L34.7 19.2Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecyclingWhite);
export default __webpack_public_path__ + "static/media/recycling_white.1b508b3dc4c857aafc6d8fa0c39d5f42.svg";
export { ForwardRef as ReactComponent };